/**
 * Copy the CDC onboarding surfaces share. A step is described both on the hub row that leads to it
 * and inside the step itself, and the same waiting state is reported from more than one place - so
 * the wording lives here once rather than being kept in sync by hand.
 */

export const PROVISIONING_MESSAGE =
  'Eon is connecting to your VPC endpoint. This usually takes a few minutes.';

export const SQL_STEP_DESCRIPTION =
  'Creates the replication user and configures tables for replication.';

export const UNMEASURED_TOOLTIP =
  'Eon has not read this off the running database yet. Click "Check & Continue" below to check';
